<header class="e-header" role="banner">

    <div class="e-top-navigation">
        <nav mat-tab-nav-bar role="navigation" aria-label="Company information, help guides and account related navigation links">
            <a mat-tab-link [routerLink]="aboutEuromonitorRoute" routerLinkActive="e-active">About Euromonitor</a>

            <button mat-tab-link [matMenuTriggerFor]="helpMenu" tabindex="-1"
                [class.e-active]="hasActiveChildRoute(helpMenuItems) || hasActiveChildRoute(referenceMenuItems)">
                Help Guide and Videos
            </button>
            <mat-menu #helpMenu="matMenu" xPosition="before" backdropClass="e-menu-backdrop">
                <div class="e-menu-items">
                    <!-- TODO: Hidden for MVP release
                    <h5>Help</h5>
                    <button mat-menu-item (click)="openGuidedHelp()">Via Guided Help</button>
                    <button *ngFor="let item of helpMenuItems" mat-menu-item (click)="navigateTo(item.url)">{{item.name}}</button>
                    -->
                    <h5>Reference</h5>
                    <button *ngFor="let item of referenceMenuItems" mat-menu-item (click)="navigateTo(item.url)">{{item.name}}</button>
                </div>
            </mat-menu>

            <button mat-tab-link [matMenuTriggerFor]="supportMenu" tabindex="-1"
                [class.e-active]="hasActiveChildRoute(supportMenuItems)">
                Contact Us
            </button>
            <mat-menu #supportMenu="matMenu" xPosition="before" backdropClass="e-menu-backdrop">
                <div class="e-menu-items">
                    <h5>Support</h5>
                    <button *ngFor="let item of supportMenuItems" mat-menu-item (click)="navigateTo(item.url)">{{item.name}}</button>
                </div>
            </mat-menu>

            <button mat-tab-link class="e-user-menu-trigger" [matMenuTriggerFor]="userMenu" aria-label="User profile and settings menu" tabindex="-1">
                <i class="fas fa-user-cog"></i>
            </button>
            <mat-menu #userMenu="matMenu" xPosition="before" backdropClass="e-menu-backdrop" classList="e-user-menu">
                <div class="e-current-user">
                    <span *ngIf="userData.name">{{userData.name}}</span>
                    <span *ngIf="userData.city">{{userData.city}}</span>
                </div>
                <div class="e-menu-items">
                    <button *ngFor="let item of menuItems" mat-menu-item (click)="navigateTo(item.url, item.redirect)">{{item.name}}</button>
                    <button *ngIf="hasMultipleSubscriptions" mat-menu-item (click)="navigateOut()">Subscriptions</button>
                    <button mat-menu-item (click)="navigateTo(logoutRoute)">Log Out</button>
                </div>
            </mat-menu>

        </nav>
    </div>

    <div class="e-branding-bar">
        <div>
            <button class="e-logo" (click)="navigateTo(homeRoute)" aria-label="Return to the home page"></button>
            <div class="e-brand-symbol"></div>
            <div class="e-branding-bar-content">
                <nav mat-tab-nav-bar class="e-main-navigation" role="navigation" aria-label="Main application features navigation">
                    <a *ngFor="let item of navMenuItems" mat-tab-link [routerLink]="item.url" routerLinkActive="e-active">
                        <span>{{ item.name }}</span>
                    </a>
                </nav>
                <div *ngIf="dataUpdatedDateTime" class="e-data-updated-date-time">
                    Data Updated on {{dataUpdatedDateTime | date:'MMM d, y'}} at 12:00am GMT
                </div>
            </div>
        </div>
    </div>

</header>
